module.exports = __webpack_public_path__ + "img/2.b4fcab27.png";